import React, { FC, useState, useRef, useEffect } from 'react';
import { Setting } from '../App';
import classes from '../asset/css/main.module.css';
import { usePaymentMethodUpdate } from '../hooks/use-payment-method-update';
import { Method } from '../components/payment-method/Method';
import { useHistory } from 'react-router-dom';
import { PaymentMethodViewType } from '../types/view/payment-method-view-type';

export const PaymentMethod: FC<{ setting: Setting }> = ({ setting }) => {
  const history = useHistory();
  const [subscriptionContractId, setSubscriptionContractId] = useState('');
  const [paymentMethod, setPaymentMethod] = useState<PaymentMethodViewType>();

  const { update } = usePaymentMethodUpdate(setting, setSubscriptionContractId, setPaymentMethod);

  const root = useRef<HTMLDivElement>(null);
  useEffect(() => {
    setting.resize(root.current?.clientHeight ?? 0);
  }, [setting, root.current?.clientHeight, paymentMethod]);

  return (
    <>
      <div className={classes.mypage_subsc_container} ref={root}>
        <Method
          paymentMethod={paymentMethod}
          updatePaymentMethodFunc={() => {
            update(subscriptionContractId, () => {
              history.push('/paymentMethod/complete');
            });
          }}
        />
      </div>
    </>
  );
};
